import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import { Col, Row, Button } from "reactstrap";
import { RenderAmount, INVOICE_TYPE, INVOICE_TYPE_NEED_VAT_CALC } from "../../utils";
import { useFormContext } from "react-hook-form";
import "./DeliveryInfo.scss";
import { useNavigate } from 'react-router'
import { get } from "../../helpers/api_helper";
import moment from 'moment';
import { ModalShowScanInvetory } from "./components/modal-show-scan-invetory";

const DeliveryInfo = forwardRef((props, ref) => {
  const {
    billId,
    listProduct,
    status,
    orderData,
    handleCancel,
    statusOder,
    handleUpdateStatus,
    loading,
    handleCreated,
    handleConfirmed,
    handlePreparing,
    handleDeliver,
    handleCheckPackage,
    handlePackageIn,
    handleWaitingPay,
    handleWaitingExportVAT,
    handleFinish,
    exportRef,
    getListCostDelivery,
    isShowShipMethod,
    sendBillMail,
    statusAllowUpdate,
    cancelReason,
    isPurchase,
    isExportVAT,
    handleSuccessfulPay,
    handleSuccessfulExportVAT,
    handleCreateDraftVAT,
    handleDelete,
  } = props;
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = user?.role === 'ADMIN';
  const isStatusInfo = status === 'INFO';
  const isStatusCreate = status === 'CREATE';
  const isStatusUpdate = status === 'UPDATE';
  const {
    getValues,
    watch,
  } = useFormContext();
  const [histories, setHistories] = useState([]);
  const [costDeliver, setCostDeliver] = useState(getValues().costDeliver);
  const [invoiceType, setInvoiceType] = useState(getValues().invoiceType);
  const [deposit, setDeposit] = useState(getValues().deposit);
  const [showScanInventory, setShowScanInventory] = useState(false);
  useEffect(() => {
    setCostDeliver(getValues().costDeliver);
  }, [watch('costDeliver')]);

  useEffect(() => {
    setInvoiceType(getValues().invoiceType);
  }, [watch('invoiceType')]);

  useEffect(() => {
    setDeposit(getValues().deposit);
  }, [watch('deposit')]);
  useEffect(() => {
    if (billId) {
      get(`/bills/history/${billId}`)
        .then((data) => {

          const listHistories = data.filter(e => e.type === "DELIVERY_STATUS" && ['GHTK', 'VIETTELPOST'].includes(e.deliveryName)).map(e => {
            if (e.deliveryName === 'GHTK') {
              return {
                status: e.info.statusText,
                createdAt: moment(e.info.modified).toDate(),
                deliveryId: e.deliveryId
              }
            }
            if (e.deliveryName === 'VIETTELPOST') {
              return {
                status: e.info.statusName,
                createdAt: moment(e.info.orderStatusdate, 'DD/MM/YYYY HH:mm:ss').toDate(),
                deliveryId: e.deliveryId
              }
            }
          })
          setHistories(listHistories)
        })
    }
  }, []);

  const unitTotal = () => {
    let total = 0;
    if (listProduct.length === 0) return 0;
    listProduct.forEach((item) => {
      if (item.cost) {
        total += Number(item.cost) * Number(item.quantity);
      }
    });
    return Number(total);
  };

  const totalWeight = () => {
    let total = 0;

    listProduct.forEach((item) => {
      total += (item.productWeight || 0) * (item.quantity || 0)
    });

    return total;
  }

  const totalItems = () => {
    let total = 0;
    listProduct?.forEach((item) => {
      total += Number(item.quantity);
    });
    return total;
  }
  const totalProduct = () => {
    let total = 0;
    if (listProduct.length === 0) return 0;
    listProduct.map((item) => {
      if (item.price && item.quantity) {
        total += Number(item.quantity) * (Number(item.price) - Number(item.discountPerQuantity || 0));
      }
    });
    return Number(total);
  };

  const vatValue = () => {
    let total = 0;
    if (listProduct.length === 0) return 0;
    listProduct.map((item) => {
      if (item.price && item.quantity) {
        total += Number(item.quantity) * (Number(item.price) - Number(item.discountPerQuantity || 0)) * Number(item.vatPercent || item?.product?.vatPercent || 0) / 100;
      }
    });
    return Number(total);
  }
  const total = () => {
    let totalPrice = totalProduct();
    if (INVOICE_TYPE_NEED_VAT_CALC.includes(invoiceType)) {
      totalPrice += vatValue();
    }

    if (costDeliver) {
      totalPrice += +costDeliver;
    }
    return Number(totalPrice);
  };

  const restTotal = () => {
    return total() - deposit;
  }
  useImperativeHandle(ref, () => ({
    total,
    totalProduct,
    restTotal,
    totalItems,
  }));

  const renderSendMailButton = () => {
    return <Button
      className="btn btn-warning"
      style={{ marginRight: 5 }}
      type="button"
      onClick={sendBillMail}
    >
      Gửi Hoá đơn Mail
    </Button>
  }
  const renderExportExcelButton = () => {
    return <Button style={{ marginRight: 5 }} className="btn btn-warning waves-effect waves-light" onClick={() => {
      exportRef.current.exportToCSV();
    }}>Xuất Excel</Button>
  }
  const renderExportExcelWithCostButton = () => {
    if (!isAdmin) return null;
    return <Button style={{ marginRight: 5 }} className="btn btn-warning waves-effect waves-light" onClick={() => {
      exportRef.current.exportToCSVWithCost();
    }}>Xuất Excel kèm vốn</Button>
  }

  const renderPrintBillButton = () => {
    return <Button
      onClick={() => window.open(`/print-bill-by-id/${billId}`, '_blank')}
      style={{ marginRight: 5 }}
      className="btn btn-primary waves-effect waves-light"
    >
      In
    </Button>
  }

  const renderSetDeliveryProviderButton = () => {
    return <Button
      className="btn btn-danger"
      style={{ marginRight: 5 }}
      type="button"
      onClick={getListCostDelivery}
    >
      Gửi CPN
    </Button>
  }


  const renderSetCreatedButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleCreated}
    >
      Chốt
    </Button>
  }

  const renderSetConfirmAndPrintBillButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={() => handleConfirmed(() => {
        window.open(`/print-bill-by-id/${billId}`, '_blank');
        navigate('/status-oder');
      })}
    >
      Xác nhận Và In
    </Button >



  }

  const renderSetPreparingButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handlePreparing}
    >
      Chuẩn bị hàng
    </Button>
  }


  const renderSetCheckPackageButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleCheckPackage}
    >
      Kiểm hàng
    </Button>
  }

  const renderSetPackageInButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handlePackageIn}
    >
      Đóng gói
    </Button>
  }

  const renderSetWaitingPayButton = () => {
    if (isPurchase === null) {
      return <Button
        className="btn btn-danger waves-effect waves-light"
        style={{ marginRight: 5 }}
        type="button"
        onClick={handleWaitingPay}
      >
        Chuyển "Chờ thanh toán"
      </Button>
    }
    if (isPurchase === false) {
      return <Button
        className="btn btn-success waves-effect waves-light"
        style={{ marginRight: 5 }}
        type="button"
        onClick={handleSuccessfulPay}
      >
        Chuyển "Đã thanh toán"
      </Button>
    }
    return null
  }

  const renderSetWaitingExportVATButton = () => {
    if (isExportVAT === null) {
      return <Button
        className="btn btn-danger waves-effect waves-light"
        style={{ marginRight: 5 }}
        type="button"
        onClick={handleWaitingExportVAT}
      >
        Chuyển "Chờ xuất HD Đỏ"
      </Button>
    }
    if (isExportVAT === false) {
      return <Button
        className="btn btn-success waves-effect waves-light"
        style={{ marginRight: 5 }}
        type="button"
        onClick={handleSuccessfulExportVAT}
      >
        Chuyển "Đã xuất HD Đỏ"
      </Button>
    }
    return null
  }

  const renderSetWaitPickupButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleDeliver}
    >
      Chờ lấy hàng
    </Button>
  }

  const renderSetFinishButton = () => {
    return <Button
      className="btn btn-success waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleFinish}
    >
      Hoàn thành
    </Button>
  }

  const renderSetCancelButton = () => {
    return <Button
      className="btn btn-warning waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleCancel}
    >
      Hủy
    </Button>
  }

  const renderSetEditButton = () => {
    return <Button
      className="btn btn-info waves-effect waves-light"
      type="submit"
      style={{ marginRight: 5 }}
      onClick={handleUpdateStatus}
    >
      Sửa
    </Button>
  }

  const renderCreateDraftVATButton = () => {
    if (![INVOICE_TYPE.E_VAT_INVOICE, INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE].includes(invoiceType)) return null;
    if (orderData?.isExportVAT === true) return null
    return <Button
      className="btn btn-info waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleCreateDraftVAT}
    >
      Tạo/Cập nhật bản nháp VAT
    </Button>
  }

  const renderShowScanInventoryButton = () => {
    return <Button
      className="btn btn-info waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={() => {
        setShowScanInventory(true);
      }}
    >
      Xem scan
    </Button>
  }
  const renderDeleteButton = () => {
    return <Button
      className="btn btn-danger waves-effect waves-light"
      style={{ marginRight: 5 }}
      type="button"
      onClick={handleDelete}
    >
      Xóa
    </Button>
  }
  return (
    <div className="delivery-info">
      <Row>
        <Col>
          <h5>Thông tin vận chuyển</h5>
          {histories?.length > 0 ? <h6>Mã: <strong>{histories[0].deliveryId}</strong></h6> : ''}
          <ul>
            {histories &&
              histories.map((item, index) => (
                <li><b>{moment(item.createdAt).format('HH:mm:ss DD-MM-YYYY')}</b>: {item.status}</li>
              ))}
          </ul>

        </Col>
        <Col>
          <Row className="justify-content-between mt-4">
            <p className="text-right col-md-10">Khối lượng:</p>
            <p className="col-md-2 text-right">
              {<RenderAmount price={totalWeight()} decimalScale={3} suffix=" g" />}
            </p>
          </Row>
          {isAdmin ? <Row className="justify-content-between">
            <p className="text-right col-md-10">Tổng tiền vốn sản phẩm:</p>
            <p className="col-md-2 text-right">
              {<RenderAmount price={unitTotal()} />}
            </p>
          </Row> : ""}

          <Row className="justify-content-between">
            <p className="text-right col-md-10">Tổng tiền sản phẩm:</p>
            <p className="col-md-2 text-right">
              {<RenderAmount price={isStatusInfo ? orderData?.productsAmount : totalProduct()} />}
            </p>
          </Row>
          {
            INVOICE_TYPE_NEED_VAT_CALC.includes(invoiceType) &&
            <Row className="justify-content-between">
              <p className="text-right col-md-10">Thuế VAT:</p>
              <p className="col-md-2 text-right">
                {<RenderAmount price={isStatusInfo ? orderData?.vatAmount : vatValue()} />}
              </p>
            </Row>
          }

          <Row className="justify-content-between">
            <p className="text-right col-md-10">Phí vận chuyển:</p>
            <p className="col-md-2 text-right">
              {<RenderAmount price={isStatusInfo ? orderData?.costDeliver : costDeliver || 0} />}
            </p>
          </Row>
          <Row className="justify-content-between">
            <p className="text-right col-md-10">Tổng cộng:</p>
            <p className="col-md-2 text-right">
              {<RenderAmount price={isStatusInfo ? orderData?.total : total()} />}
            </p>
          </Row>
          {
            !isStatusInfo && deposit > 0 ?
              <>
                <Row className="justify-content-between">
                  <p className="text-right col-md-10">Ứng trước:</p>
                  <p className="col-md-2 text-right">
                    {<RenderAmount price={deposit} />}
                  </p>
                </Row>
                <Row className="justify-content-between">
                  <p className="text-right col-md-10">Tiền phải trả còn lại:</p>
                  <p className="col-md-2 text-right">
                    {<RenderAmount price={total() - deposit} />}
                  </p>
                </Row>
              </>
              : ''
          }
          {
            isStatusInfo && orderData?.deposit > 0 ?
              <>
                <Row className="justify-content-between">
                  <p className="text-right col-md-10">Ứng trước:</p>
                  <p className="col-md-2 text-right">
                    {<RenderAmount price={orderData?.deposit} />}
                  </p>
                </Row>
                <Row className="justify-content-between">
                  <p className="text-right col-md-10">Tiền phải trả còn lại:</p>
                  <p className="col-md-2 text-right">
                    {<RenderAmount price={orderData?.total - orderData?.deposit} />}
                  </p>
                </Row>
              </>
              : ''
          }
        </Col>
      </Row>
      <Row>
        <Col>
          {statusOder === 'CANCELED' ? <div>
            <h5 className="text-danger text-end">Lý do huỷ: {cancelReason || "Không có lý do"}</h5>
          </div> : null}
        </Col>
      </Row>
      <Row>
        <Col>
          {loading ? <div className="delivery-info_wrapButton">
            <h5>Đang thực hiện. Vui lòng chờ</h5>
          </div>
            :
            <>
              <div className="delivery-info_wrapButton">

                {isStatusCreate ?
                  <Button
                    className="btn btn-info waves-effect waves-light"
                    type="submit"
                  >
                    Tạo
                  </Button>
                  : ""}
                {isStatusUpdate ? <>
                  <Button
                    className="btn btn-info waves-effect waves-light"
                    style={{ marginRight: 5 }}
                    type="submit"
                  >
                    Lưu
                  </Button>
                  <Button
                    className="btn btn-warning waves-effect waves-light"
                    style={{ marginRight: 5 }}
                    type="button"
                    onClick={() => navigate(0)}
                  >
                    Huỷ Lưu
                  </Button>
                </> : ''}
                {isStatusInfo ?
                  <>
                    {renderExportExcelButton()}
                    {renderExportExcelWithCostButton()}
                    {/* {renderSendMailButton()} */}
                    {renderPrintBillButton()}
                    {statusAllowUpdate?.CREATED ? renderSetCreatedButton() : null}

                    {statusAllowUpdate?.CONFIRMED ? renderSetConfirmAndPrintBillButton() : null}
                    {/* {statusAllowUpdate?.PREPARING ? renderSetPreparingButton() : null} */}
                    {/* {statusAllowUpdate?.CHECK_PACKAGE ? renderSetCheckPackageButton() : null} */}
                    {/* {statusAllowUpdate?.IN_PACKAGE ? renderSetPackageInButton() : null} */}
                    {statusAllowUpdate?.WAIT_CUSTOMER_PICK_UP ? renderSetWaitPickupButton() : null}
                    {isShowShipMethod && statusAllowUpdate?.DELIVERING ? renderSetDeliveryProviderButton() : ''}

                    {statusAllowUpdate?.FINISHED ? renderSetFinishButton() : null}
                    {statusAllowUpdate?.CANCELED ? renderSetCancelButton() : null}
                    {statusAllowUpdate?.EDIT ? renderSetEditButton() : null}
                    <Button onClick={() => {
                      navigate(`/oder-manager?duplicateId=${billId}`)
                    }}>
                      Sao chép
                    </Button>
                    {isAdmin && renderDeleteButton()}
                  </>
                  : ''}
              </div>

              {isStatusInfo ?
                <div className="delivery-info_wrapButton">

                  {statusAllowUpdate?.WAITING_PAY ? renderSetWaitingPayButton() : null}
                  {statusAllowUpdate?.WAITING_EXPORT_VAT ? renderSetWaitingExportVATButton() : null}
                  {renderCreateDraftVATButton()}
                  {renderShowScanInventoryButton()}

                </div>
                : null}

            </>
          }
        </Col>
      </Row>
      {showScanInventory && <ModalShowScanInvetory isOpen={true} toggle={() => setShowScanInventory(false)} billId={billId} />}
    </div >
  );
});

export default DeliveryInfo;

DeliveryInfo.propTypes = {
  listProduct: PropTypes.array,
  costDelivery: PropTypes.number,
  status: PropTypes.string,
  statusOder: PropTypes.string,
  handleCancel: PropTypes.func,
  handleUpdateStatus: PropTypes.func,
  loading: PropTypes.bool,
  handleConfirmed: PropTypes.func,
  handlePreparing: PropTypes.func,
  handleDeliver: PropTypes.func,
  handleFinish: PropTypes.func,
  handlePrint: PropTypes.func,
  getListCostDelivery: PropTypes.func,
  printRef: PropTypes.any,
  exportRef: PropTypes.any,
  isShowShipMethod: PropTypes.bool,
  sendBillMail: PropTypes.func

};
